import { useState } from 'react'
import { PencilIcon } from '@heroicons/react/outline'

import { Role } from 'models'
import { ProtectedSection } from 'components/ProtectedSection'
import { useViewClient } from 'modules/Clients/hooks/useViewClient'
import { CancelChipsModal } from './CancelChipsModal'

const defaultChipsListOptions = {
  page: 1,
  count: true,
  limit: 100,
  sort: { item_status_created_at: -1 }
}

export function SimulateCancellationButton() {
  const { client, listChips } = useViewClient()
  const [isOpen, setIsOpen] = useState(false)

  if (!client) return null

  return (
    <ProtectedSection roles={[Role.MANAGER, Role.FINANCE]}>
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        className="h-9 flex items-center justify-center px-4 rounded-md border border-gray-300 bg-white text-sm font-medium text-emerald-700 hover:bg-gray-50 focus:outline-none whitespace-nowrap"
      >
        <span>Simular cancelamento</span>
        <PencilIcon className="ml-3 h-4 w-4" aria-hidden="true" />
      </button>

      <CancelChipsModal
        isOpen={isOpen}
        setOpen={setIsOpen}
        clientId={client.id}
        onCanceled={() => listChips(defaultChipsListOptions)}
      />
    </ProtectedSection>
  )
}
